import { orchestrator } from 'satcheljs';
import { isCapabilityEnabled } from 'owa-capabilities';
import { newHeaderCapability } from 'owa-capabilities-definitions/lib/newHeaderCapability';
import { updateIsSuiteHeaderRendered } from 'owa-suite-header-store';
import tryRunPendingAutoOpenOperation from '../utils/tryRunPendingAutoOpenOperation';

// once suite header is rendered, trigger any pending auto-open operation
orchestrator(updateIsSuiteHeaderRendered, ({ isRendered }) => {
    if (!isCapabilityEnabled(newHeaderCapability) && isRendered) {
        tryRunPendingAutoOpenOperation();
    }
});
